export default {
    navigationBarTitleText: 'AI灵感'
  };
  